import { render, staticRenderFns } from "./user.vue?vue&type=template&id=dc80cc26&"
import script from "./user.vue?vue&type=script&lang=ts&"
export * from "./user.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc80cc26')) {
      api.createRecord('dc80cc26', component.options)
    } else {
      api.reload('dc80cc26', component.options)
    }
    module.hot.accept("./user.vue?vue&type=template&id=dc80cc26&", function () {
      api.rerender('dc80cc26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/searchbar/decorators/user.vue"
export default component.exports